import { useQuery } from '@tanstack/react-query';
import { API_URL } from '../config.js';
import { toApiError } from '../lib/api-error';

export type OrgMember = {
  id: string;
  userId: string;
  role: 'admin' | 'member';
  createdAt: string;
  displayName: string | null;
  primaryEmail: string | null;
};

type OrgMembersResponse = {
  ok: boolean;
  items: OrgMember[];
};

export function useOrgMembers(opts?: { enabled?: boolean }) {
  return useQuery<OrgMembersResponse>({
    queryKey: ['org-members'],
    queryFn: async () => {
      const res = await fetch(`${API_URL}/org/members`, { credentials: 'include' });
      if (!res.ok) {
        throw await toApiError(res, 'Failed to load organization members');
      }
      return res.json();
    },
    enabled: opts?.enabled ?? true,
  });
}
